module.exports = __webpack_public_path__ + "img/diamond-filled.2458b66f.svg";